import React, { useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

const FormModal = ({
  title,
  action,
  isModalOpen,
  setIsModalOpen,
  children,
  isSubmitting,
  actionButton = "Guardar",
  cancelButton = "Cerrar",
  size = "md",
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (isModalOpen == true) {
      onOpen();
    } else {
      closeModal();
    }
  }, [isModalOpen]);

  const callAction = () => {
    action();
  };

  const closeModal = () => {
    setIsModalOpen(false);
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={closeModal} size={size}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textTransform="uppercase" fontSize="1rem">
            {title}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>{children}</ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={closeModal}>
              {cancelButton}
            </Button>
            <Button
              colorScheme="blue"
              onClick={() => callAction()}
              isDisabled={isSubmitting}
            >
              {actionButton}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default FormModal;
